export enum CompanyCode {
  ALL = 'ALL',
  PNC = 'PNC',
  BW = 'BW'
}
